import { useEffect, useState } from 'react'
import axios from 'axios';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from 'swiper/modules';
import "swiper/css";
import 'swiper/css/navigation';
import ArrowNextMobile from '../shared/ArrowNextMobile';
import ArrrowPrevMobile from '../shared/ArrrowPrevMobile';
import clsx from 'clsx';
import useStore from '../../store/store';
import { isMobile } from 'react-device-detect';
import '../../App.scss';
import NavigationMobile from '../mobile/NavigationMobile';

const monthNames = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

const groupByMonth = (data) => {
  return data.reduce((acc, item) => {
    const key = `${item.y}-${item.m}`;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});
};
const shortDays = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

const DateChoiceMobile = () => {
  const [dates, setDates] = useState([]);
  const [allowedLengths, setAllowedLengths] = useState([]);
  const { setArrivalDate, arrivalDate, rooms, step } = useStore();
  useEffect(() => {
    if (rooms.length > 0)
      setAllowedLengths(Array.from(
        new Set(
          rooms.flatMap(room =>
            room.people.map(person => Number(person.program_length)).filter(Boolean)
          )
        )
      ));
    axios.get(`https://kivach.ru/calc-new/api_new.php?method=program_dates&lengths`).then(({ data }) => setDates(() => groupByMonth(data.res)))
  }, [rooms]);

  const handleClickOnDate = (item) => {
    setArrivalDate(item.date);
  }

  const generateDaysArray = (year, month) => {
    const daysInMonth = new Date(year, month, 0).getDate();
    const firstDayOfWeek = new Date(year, month - 1, 1).getDay(); 
    const offset = (firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1); 

    const daysArray = Array(offset).fill(null).concat(
      Array.from({ length: daysInMonth }, (_, i) => i + 1)
    );

    return daysArray;
  };

  return (
    <>
      <div className='MobileMain__wrapper'>
        <div className='MobileMain__step roboto-regular'>Шаг {step}/5</div>
        <h2>Выберите дату заезда*</h2>
        <Swiper
          className='DateChoiceMobile__swiper'
          modules={[Navigation]}
          slidesPerView={isMobile ? 1 : 3}
          spaceBetween={0}
        >
          <ArrrowPrevMobile />
          {Object.entries(dates).map(([key, items]) => {
            const [year, month] = key.split("-");
            const freeDate = items.filter(item => {
              const lengthsArray = item.lengths.split(', ').map(length => Number(length.trim()));
              return allowedLengths.every(length => lengthsArray.includes(length));
            })
            
            const optimizedDaysArray = generateDaysArray(year, month);
            const freeDaysSet = new Set(freeDate.map(item => item.d)); 
            return (
              <SwiperSlide key={key}>
                <div className='dates_swiper__slide'>
                  <h2>
                    {monthNames[month - 1]} {year}
                  </h2>
                  <div className='DateChoiceMobile__dates-list'>
                    {shortDays.map(day => (<span key={day} className='day-name'>{day}</span>))}
                    {
                      optimizedDaysArray.map((day, idx) => {
                        const isFree = freeDaysSet.has(`${day}`);
                        const dayData = freeDate.find(item => item.d === `${day}`);
                      
                        return (
                          <span
                            key={idx + day} // Уникальность гарантируется индексом
                            className={clsx(
                              'DateChoiceMobile__day',
                              isFree && 'free',
                              dayData?.date === arrivalDate && 'active'
                            )}
                            onClick={isFree ? () => handleClickOnDate(dayData) : undefined}
                          >
                            {day}
                          </span>
                        );
                      })
                    }
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
          <ArrowNextMobile />
        </Swiper>

        <div className='DateChoiceMobile__notification'>
          <span className='day free'>7</span> — даты, доступные для заезда
        </div>
        <div className='DateChoiceMobile__notification'>
          * Наличие свободных номеров проверяет отдел бронирования после получения заявки.
        </div>
        {isMobile && <NavigationMobile isBtnDisabled={arrivalDate === null} />}
      </div>
    </>
  )
}

export default DateChoiceMobile